import OOpeningHoursMobilia from './o-opening-hours-mobilia.vue';

export default OOpeningHoursMobilia;